var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    width: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z",
    fill: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "nonzero",
    d: "M18.477 17.954L2.392 2.13c0-.13-.13-.13-.261-.13 0 0-.131.13-.131.262v15.953c0 .131.13.262.262.262H3.7c.13 0 .262-.13.262-.262V17.17H5.4v1.046c0 .131.13.262.262.262h1.307a.28.28 0 0 0 .262-.262V17.17h1.438v1.046c0 .131.131.262.262.262h1.307a.28.28 0 0 0 .262-.262V17.17h1.438v1.046c0 .131.131.262.262.262h1.308a.28.28 0 0 0 .261-.262V17.17h1.439v1.046c0 .131.13.262.261.262h2.746c.131 0 .262 0 .262-.13v-.393zm-8.5-3.923H5.269V9.192l4.708 4.839z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSize);
export default __webpack_public_path__ + "static/media/size.bae1652dd140e02eaa1745427f8f5870.svg";
export { ForwardRef as ReactComponent };